import { render, staticRenderFns } from "./PatrimonioView.vue?vue&type=template&id=d22623f0"
import script from "./PatrimonioView.vue?vue&type=script&lang=js"
export * from "./PatrimonioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports